export const PhoneValidator = () => ({
  countryCode: null,
  phone: "",
  error: "",
  isValid: true,
  validationMessages: null,

  init() {
    this.countryCode = this.$refs.countryCodeSelect.value
    this.phone = this.$refs.phoneInput.value

    try {
      const messagesAttr = this.$el.getAttribute("data-validation-messages")
      if (messagesAttr) {
        this.validationMessages = JSON.parse(messagesAttr)
      }
    } catch (e) {
      console.error("Cannot parse phone validation messages.", e)
    }

    this.validate()

    this.$nextTick(() => {
      this.$dispatch("phone-validation-changed", { isValid: this.isValid })
    })
  },

  changeCountryCode() {
    this.countryCode = this.$refs.countryCodeSelect.value
    this.validate()

    this.$dispatch("phone-validation-changed", { isValid: this.isValid })
  },

  changePhone() {
    this.phone = this.$refs.phoneInput.value
    this.validate()

    this.$dispatch("phone-validation-changed", { isValid: this.isValid })
  },

  validate() {
    this.isValid = true
    this.error = ""

    if (!this.phone || this.phone.trim() === "") {
      this.error = "電話號碼不能為空"
      this.isValid = false
      return
    }

    if (this.countryCode === "+886") {
      if (!this.phone.startsWith("09")) {
        this.error = this.validationMessages?.taiwan?.format
        this.isValid = false
      } else if (this.phone.length !== 10) {
        this.error = this.validationMessages?.taiwan?.length
        this.isValid = false
      }
    } else if (this.countryCode === "+86") {
      if (this.phone.length !== 11) {
        this.error = this.validationMessages?.china?.length
        this.isValid = false
      }
    }
  },
})
